import { HashRouter } from 'react-router-dom';

import TransitionWrapper from './animate-js/class/transition/transition_wrapper';

function App() {

  return (
    <HashRouter>
      <TransitionWrapper />
    </HashRouter >
  );
}

export default App;
